import { render, staticRenderFns } from "./__outbound_channel_form.vue?vue&type=template&id=18625e82&scoped=true&"
import script from "./__outbound_channel_form.vue?vue&type=script&lang=js&"
export * from "./__outbound_channel_form.vue?vue&type=script&lang=js&"
import style0 from "./__outbound_channel_form.vue?vue&type=style&index=0&id=18625e82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18625e82",
  null
  
)

export default component.exports